/// <amd-module name="TFS/Admin/Views/ProfileSettings/OrganizationsView/Contracts" />

export interface Organization {
    id: string;
    name: string;
    description: string;
    lastUserAccess: Date;
    isOwner: boolean;
    isActive: boolean;
}